import { Refresh } from '@mui/icons-material';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Bin from '../../../assets/Bin.tsx';
import { Edit } from '../../../assets/Edit.tsx';
import { IconButton } from '../../../components/IconButton/IconButton.tsx';
import { ExamView } from '../../../graphql/types.gen.ts';
import { GENERAL_GROUP_NAME } from '../../../index.tsx';
import { useLastGroupQuery } from '../../FormPage/LoginPage/loginPage.gen.ts';
import {
	GetLessonsHomeworkBySlugDocument,
	useGetLessonsForSelectFromGroupQuery,
	useLessonHomeworkExamsUpdateMutation,
} from '../../Lessons/lessons.gen.ts';
import { SmallCards } from '../SmallCards.tsx';
import { useGetBackofficeBidsArray } from '../helpers/useGetBackofficeBidsArray.ts';
import { vulnerabilityToString } from '../helpers/vulnerabilityToString.ts';
import { BackofficeBidSequence } from './BackofficeBidSequence/BackofficeBidSequence.tsx';
import { BackofficeTestEditMode } from './BackofficeTestEditMode.tsx';
interface IBackofficeTest {
	test: ExamView;
	handleEditClick: () => void;
	handleLeaveEditClick: () => void;
	editMode: boolean;
	onSave: (id?: string) => void;
	handleRemoveClick: (id: string) => void;
	index: number;
	isForLesson: boolean;
	lessonSlug?: string;
}
export const BackofficeTest = (props: IBackofficeTest) => {
	const { data: chosenGroup } = useLastGroupQuery();
	const [lesson] = useState('');

	const groupCode = chosenGroup?.me?.recentlyUsedGroupId;
	const [updateHomework, { loading: updateHomeworkLoading }] = useLessonHomeworkExamsUpdateMutation({
		refetchQueries: [GetLessonsHomeworkBySlugDocument],
	});
	const {
		test,
		lessonSlug,
		handleEditClick,
		editMode,
		onSave,
		handleLeaveEditClick,
		handleRemoveClick,
		index,
		isForLesson,
	} = props;
	const { arr } = useGetBackofficeBidsArray(test);

	const { data: lessonsForSelect } = useGetLessonsForSelectFromGroupQuery({
		variables: {
			code: groupCode || GENERAL_GROUP_NAME,
			lessonsInput2: {
				filters: {
					difficultyLevel: [],
					tags: [],
				},
				pagination: {
					limit: 100,
					offset: 0,
				},
			},
		},
	});
	if (editMode)
		return (
			<BackofficeTestEditMode
				isForLesson={isForLesson}
				index={index}
				test={test}
				handleEditClick={handleEditClick}
				handleLeaveEditClick={handleLeaveEditClick}
				onSave={onSave}
			/>
		);
	const handleLessonChange = async (event: SelectChangeEvent<string | null>) => {
		const {
			target: { value: passedSlug },
		} = event;

		const slug = passedSlug == null ? lessonSlug : passedSlug;
		const currentLesson = lessonsForSelect?.group?.lessons?.items?.find((lesson) => lesson.slug === slug);

		const response = await updateHomework({
			variables: {
				input: {
					slug: isForLesson ? currentLesson.slug : slug,
					groupCode: groupCode || GENERAL_GROUP_NAME,
					homeworkExamIds:
						passedSlug == null
							? [
									...currentLesson.homework
										.filter((homework) => homework.id !== test.id)
										.map((homework) => homework.id),
								]
							: [...currentLesson.homework.map((homework) => homework.id), test.id],
				},
			},
		});
		if (response.data?.lessonHomeworkExamsUpdate?.__typename === 'LessonRevisionCreateSuccessView') {
			onSave();
		} else {
			toast.error('Coś poszło nie tak, spróbuj ponownie. 😢');
		}
	};

	return (
		<div className="backoffice__test">
			<p className="backoffice__test-number">{index || 1}.</p>
			<div className="backoffice__test-content">
				<div className="backoffice__cards-tags">
					<div className="backoffice__cards-tags-wrapper">
						<div className="backoffice__tags">
							<p
								className={`allTests__tag allTests__tag--${test.tags[0].toLowerCase().replace(/\s+/g, '-')}`}
							>
								{test.tags[0]}
							</p>
							{
								<p className={`allTests__tag allTests__tag--${test.difficultyLevel.toLowerCase()}`}>
									{test.difficultyLevel}
								</p>
							}
						</div>
						<SmallCards cards={test.definition.cards} />
						<p className="backoffice__heading">Karty gracza S</p>
					</div>
				</div>
				<div className="backoffice__bidSequenceWrapper">
					<div>
						<BackofficeBidSequence arr={arr} vulnerability={test?.vulnerability} />
						<p className="backoffice__heading">{vulnerabilityToString(test.vulnerability)}</p>
					</div>
				</div>
			</div>
			<div className="backoffice__lessonPicker">
				{!updateHomeworkLoading ? (
					lessonsForSelect?.group?.lessons?.items?.length > 0 && (
						<FormControl style={{ width: 220 }}>
							<InputLabel id="vulnerability-label">Przypisz do lekcji</InputLabel>
							<Select
								labelId="lesson-label"
								id="lesson"
								value={lesson}
								label="Przypisz do lekcji"
								onChange={handleLessonChange}
							>
								{lessonsForSelect.group.lessons.items.map((v, i) => {
									return (
										<MenuItem value={v.slug} key={v.slug}>
											{v.title}
										</MenuItem>
									);
								})}
								{isForLesson && (
									<MenuItem value={null} key="unassign">
										Odepnij od lekcji
									</MenuItem>
								)}
							</Select>
						</FormControl>
					)
				) : (
					<p className="lessons__loading" aria-busy="true">
						<Refresh className="allTests__spinner" />
						<p>Poczekaj...</p>
					</p>
				)}
			</div>
			<IconButton onClick={handleEditClick} Icon={<Edit />} text="Edytuj" />
			<IconButton
				onClick={() => {
					handleRemoveClick(test.id);
				}}
				Icon={<Bin />}
				text="Usuń"
			/>
			<p className="backoffice__testName">{test.name}</p>
		</div>
	);
};
